import { useQuery } from 'react-query';
import { searchActiveMindRightPartners, GetMindRightPartnersResponse } from '../api/partner.api';
import { getDataFromResponse } from '../constant/utils/react-query-utils/getDataFromResponse';

export const useSearchMindRightPartnersQuery = (searchQuery: string, limit: number = 10) => {
  return useQuery<GetMindRightPartnersResponse>(
    ['mindright-partners', searchQuery, limit],
    async () => {
      const response = await searchActiveMindRightPartners(searchQuery, limit);
      const data = getDataFromResponse(response);
      if (data.statusCode && data.statusCode !== 200) {
        const error = new Error(data.message || 'Request failed') as Error & {
          response?: {
            data: GetMindRightPartnersResponse;
            status: number;
          };
        };
        error.response = {
          data: data,
          status: data.statusCode,
        };
        throw error;
      }
      return data;
    },
    {
      enabled: searchQuery.length >= 1, // Only fetch when search query has at least 1 character
      staleTime: 2 * 60 * 1000, // 2 minutes
      cacheTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    }
  );
};
